import axios from 'axios';
// const URL = 'https://ql4rhj1p-4000.inc1.devtunnels.ms/graphql';
const URL = 'https://d1tnc1fwz3doxp.cloudfront.net/graphql';

export interface UserData {
  userToken: string;
  libraryId?: string;
  libraryNumber?: string;
  pinNumber?: string;
  userIpAddress?: string;
  languageCode?: string;
  skipped?: boolean;
  isAdult?: boolean;
}

interface libraryMockData {
  libraryName: string;
  page: number;
  perPage: number;
  isGetAllLibrary: boolean;
  libraryType: string;
}

export interface Restriction {
  name: string;
  type: string;
}

export interface LibraryParent {
  libraryId: string;
  publicLibraryId: string | null;
  libraryName: string;
  openathensEntityId: string;
}

export interface LibraryBranch {
  libraryId: string;
  libraryName: string;
  libraryLat: number;
  libraryLon: number;
  libraryType: string;
}

export interface LibraryItem {
  libraryParent: LibraryParent;
  libraryBranch: LibraryBranch[];
  restriction: Restriction[];
  withInOrganization: boolean;
}
const USER_SIGNUP = `
  mutation InplayerUserSignup($userSignupInput: InplayerUserSignupInput!) {
    InplayerUserSignup(userSignupInput: $userSignupInput) {
      accessToken
      assetIds
      subscriptionDetail{
            expireAt
            subType
        }
      libraryList {
         withInOrganization
            libraryParent{
            libraryId
            libraryName
            libraryType
            }
            libraryBranch{
            libraryId
            libraryName
            libraryType
           }
             restriction {
          name
          type
        }
        }
    }
  }
`;

const USER_SIGNIN = `
  query InplayerUserSignin($userToken: String!) {
    InplayerUserSignin(userToken: $userToken) {
      accessToken
      assetIds
      subscriptionDetail{
            expireAt
            subType
        }
      libraryList {
      withInOrganization
            libraryParent{
            libraryId
            libraryName
            libraryType
            }
            libraryBranch{
            libraryId
            libraryName
            libraryType
           }
             restriction {
          name
          type
        }
            
        }
    }
  }
`;

const GET_LIBRARY_BY_ID = `
        query GetLibraryById($libraryId: String!) {
          GetLibraryById(libraryId: $libraryId) {
            publicLibraryId  
            libraryHub {
              mediaHubId
            }
          }
        }
      `;

const GET_USER_SIGNIN_TOKEN = `
  query validateTicket($ticket: String!) {
    validateTicket(ticket: $ticket) {
      access_token
      expires
    }
  }
`;

const GET_ALL_LIBRARY_LIST = `
  query GetAllLibraryList(
    $libraryName: String!,
    $page: Float!,
    $perPage: Float!,
    $isGetAllLibrary:Boolean!,
    $libraryType:String!
  ) {
    GetAllLibraryList(
      libraryName: $libraryName,
      page: $page,
      perPage: $perPage,
      isGetAllLibrary:$isGetAllLibrary,
      libraryType: $libraryType
    ) {
      currentPage
      totalPages
      totalItems
      perPage
      libraryList {
      withInOrganization
        libraryParent {
          libraryId
          publicLibraryId
          libraryName
          libraryType
          openathensEntityId
          }
          libraryBranch {
            libraryId
            libraryName
            libraryLat
            libraryLon
            libraryType
        }
        restriction {
          name
          type
        }
      }
    }
  }
`;

const GET_USER_LOCATION = `
query {
    GetLocationByIP { 
        longitude  
        latitude  
    }
}
`;

const makeGraphQLRequest = async (query: string, variables: any) => {
  try {
    const response = await axios.post(
      URL,
      {
        query,
        variables,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    if (response.data.errors) {
      console.error(
        response.data.errors.map((error: any) => error.message),
        '>>>>>>>>>>>>errormessage',
      );

      throw new Error(response.data.errors.map((error: any) => error.message));
    }
    return response.data.data;
  } catch (error) {
    console.error('GraphQL request failed:', error);
    throw error;
  }
};

const signupUser = async (userSignupInput: UserData) => {
  try {
    const data = await makeGraphQLRequest(USER_SIGNUP, { userSignupInput });
    if (!data || !data.InplayerUserSignup) {
      throw new Error('InplayerUserSignup not found in the response data');
    }
    return data.InplayerUserSignup;
  } catch (error) {
    console.error('Signup User error:', error);
    throw error;
  }
};

const signInUser = async (userToken: string) => {
  try {
    const data = await makeGraphQLRequest(USER_SIGNIN, { userToken });
    if (!data) {
      throw new Error('InplayerUserSignup not found in the response data');
    }
    return data.InplayerUserSignin;
  } catch (error) {
    console.error('Signup User error:', error);
    throw error;
  }
};

const fetchLibraryList = async (libraryMockData: libraryMockData) => {
  const { libraryName, page, perPage, isGetAllLibrary, libraryType } = libraryMockData || {};
  const data = await makeGraphQLRequest(GET_ALL_LIBRARY_LIST, {
    libraryName,
    page: Number(page),
    perPage: Number(perPage),
    isGetAllLibrary,
    libraryType,
  });
  return data.GetAllLibraryList.libraryList;
};

const getLibraryById = async (libraryId: string) => {
  const libraryData = await makeGraphQLRequest(GET_LIBRARY_BY_ID, { libraryId });
  return libraryData;
};

const fetchUserLocation = async () => {
  const data = await makeGraphQLRequest(GET_USER_LOCATION, null);
  return data;
};
const fetchSSOAccessToken = async (ticket: string) => {
  const data = await makeGraphQLRequest(GET_USER_SIGNIN_TOKEN, { ticket });
  return data;
};

export { signupUser, fetchLibraryList, signInUser, getLibraryById, fetchUserLocation, fetchSSOAccessToken };
